import { styled } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends, d as _objectDestructuringEmpty } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';

const _excluded = ["theme"];
const NavBarDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    position: 'relative',
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: 'row',
    p: 0,
    bg: theme.palette.common.white,
    height: [theme.shape.headerBottomHeight, theme.shape.headerTopHeight],
    boxShadow: theme.shadows[1]
  }, props);
})``;

function NavBar(_ref) {
  let props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/createElement(NavBarDiv, props);
}

export default NavBar;
